/* @flow */

import Edit from './Edit';
import View from './View';

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/youtube/index.js